"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var _get = require('lodash/get');
var _isEqual = require('lodash/isEqual');
var _cloneDeep = require('lodash/cloneDeep');
var antd_1 = require("antd");
var Rule_1 = __importDefault(require("../Rule/Rule"));
var NameField_1 = __importDefault(require("../NameField/NameField"));
var BulkEditModals_1 = __importDefault(require("../Symbolizer/BulkEditModals/BulkEditModals"));
var LocaleWrapper_1 = require("../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../locale/en_US"));
var SymbolizerUtil_1 = __importDefault(require("../../Util/SymbolizerUtil"));
var RuleTable_1 = __importDefault(require("../RuleTable/RuleTable"));
var RuleGeneratorWindow_1 = __importDefault(require("../RuleGenerator/RuleGeneratorWindow"));
require("./Style.css");
var Style = /** @class */ (function (_super) {
    __extends(Style, _super);
    function Style(props) {
        var _this = _super.call(this, props) || this;
        _this.onNameChange = function (name) {
            var style = _cloneDeep(_this.state.style);
            style.name = name;
            if (_this.props.onStyleChange) {
                _this.props.onStyleChange(style);
            }
            _this.setState({ style: style });
        };
        _this.onRuleChange = function (rule, ruleBefore) {
            var style = _cloneDeep(_this.state.style);
            var ruleIdxToReplace = style.rules.findIndex(function (r) {
                return _isEqual(r, ruleBefore);
            });
            if (ruleIdxToReplace > -1) {
                style.rules[ruleIdxToReplace] = rule;
                if (_this.props.onStyleChange) {
                    _this.props.onStyleChange(style);
                }
                _this.setState({ style: style });
            }
        };
        _this.onRulesChange = function (rules) {
            var style = _cloneDeep(_this.state.style);
            style.rules = rules;
            if (_this.props.onStyleChange) {
                _this.props.onStyleChange(style);
            }
            _this.setState({ style: style });
        };
        _this.addRule = function () {
            var style = _cloneDeep(_this.state.style);
            // TODO We need to ensure that rule names are unique
            var randomId = Math.floor(Math.random() * 10000);
            var symbolizerKind = _get(style, 'rules[0].symbolizers[0].kind');
            var newRule = {
                name: 'rule_' + randomId,
                symbolizers: [SymbolizerUtil_1.default.generateSymbolizer(symbolizerKind)]
            };
            style.rules = style.rules.concat([newRule]);
            if (_this.props.onStyleChange) {
                _this.props.onStyleChange(style);
            }
            _this.setState({ style: style });
        };
        _this.cloneRules = function () {
            var _a = _this.state, selectedRowKeys = _a.selectedRowKeys, style = _a.style;
            var styleClone = _cloneDeep(style);
            // create rules to clone
            var newRules = [];
            styleClone.rules.forEach(function (rule, index) {
                if (selectedRowKeys.includes(index)) {
                    var ruleClone = _cloneDeep(rule);
                    // TODO We need to ensure that rule names are unique
                    var randomId = Math.floor(Math.random() * 10000);
                    ruleClone.name = 'rule_' + randomId;
                    newRules.push(ruleClone);
                }
            });
            // apply cloned rules to existing ones
            styleClone.rules = styleClone.rules.concat(newRules);
            if (_this.props.onStyleChange) {
                _this.props.onStyleChange(styleClone);
            }
            _this.setState({
                style: styleClone
            });
        };
        _this.removeRules = function () {
            var _a = _this.state, selectedRowKeys = _a.selectedRowKeys, style = _a.style;
            var styleClone = _cloneDeep(style);
            var newRules = styleClone.rules.filter(function (rule, index) {
                return !selectedRowKeys.includes(index);
            });
            styleClone.rules = newRules;
            if (_this.props.onStyleChange) {
                _this.props.onStyleChange(styleClone);
            }
            _this.setState({
                selectedRowKeys: [],
                style: styleClone
            });
        };
        _this.removeRule = function (rule) {
            var style = _cloneDeep(_this.state.style);
            var newRules = style.rules.filter(function (r) { return r.name !== rule.name; });
            style.rules = newRules;
            if (_this.props.onStyleChange) {
                _this.props.onStyleChange(style);
            }
            _this.setState({ style: style });
        };
        _this.onRulesSelectionChange = function (selectedRowKeys) {
            _this.setState({
                selectedRowKeys: selectedRowKeys
            });
        };
        _this.onTableMenuClick = function (param) {
            switch (param.key) {
                case 'addRule':
                    _this.addRule();
                    break;
                case 'cloneRules':
                    _this.cloneRules();
                    break;
                case 'removeRule':
                    _this.removeRules();
                    break;
                case 'color':
                    _this.setState({ colorModalVisible: true });
                    break;
                case 'size':
                    _this.setState({ sizeModalVisible: true });
                    break;
                case 'opacity':
                    _this.setState({ opacityModalVisible: true });
                    break;
                case 'symbol':
                    _this.setState({ symbolModalVisible: true });
                    break;
                default:
            }
        };
        _this.updateAllSelected = function (updates) {
            var style = _cloneDeep(_this.state.style);
            var selectedRules = style.rules.filter(function (rule, index) {
                return _this.state.selectedRowKeys.includes(index);
            });
            selectedRules.forEach(function (rule) {
                rule.symbolizers.forEach(function (sym) {
                    updates.forEach(function (upd) {
                        var property = upd.property;
                        var value = upd.value;
                        sym[property] = value;
                        if (property === 'kind' && value === 'Icon' && sym.wellKnownName) {
                            delete sym.wellKnownName;
                        }
                        if (property === 'kind' && value === 'Mark' && sym.image) {
                            delete sym.image;
                        }
                    });
                });
            });
            if (_this.props.onStyleChange) {
                _this.props.onStyleChange(style);
            }
            _this.setState({ style: style });
        };
        _this.updateMultiColors = function (color) {
            _this.updateAllSelected([{ value: color, property: 'color' }]);
        };
        _this.updateMultiSizes = function (size) {
            _this.updateAllSelected([{ value: size, property: 'radius' }]);
        };
        _this.updateMultiOpacities = function (opacity) {
            _this.updateAllSelected([{ value: opacity, property: 'opacity' }]);
        };
        _this.updateMultiSymbols = function (symbol, kind) {
            if (kind === 'Mark') {
                _this.updateAllSelected([
                    { value: symbol, property: 'wellKnownName' },
                    { value: kind, property: 'kind' }
                ]);
            }
            else {
                _this.updateAllSelected([
                    { value: symbol, property: 'image' },
                    { value: kind, property: 'kind' }
                ]);
            }
        };
        _this.showRuleGeneratorWindow = function () {
            _this.setState({ ruleGeneratorWindowVisible: true });
        };
        _this.onRuleGeneratorWindowClose = function () {
            _this.setState({ ruleGeneratorWindowVisible: false });
        };
        /**
         * Checks if a specific menu item of multi-edit menu should be disabled.
         *
         * @param name Name of menu item
         * @param rowKeys array of selected rowkeys
         * @return boolean true if menu item should be disabled, otherwise false
         */
        _this.disableMenu = function (name, rowKeys) {
            var style = _this.state.style;
            var isValid = true;
            switch (name) {
                case 'size':
                    rowKeys.forEach(function (key) {
                        var symbolizers = style.rules[key].symbolizers;
                        symbolizers.forEach(function (symbolizer) {
                            var kind = symbolizer.kind;
                            if (kind === 'Fill' || kind === 'Text' || kind === 'Line') {
                                isValid = false;
                            }
                        });
                    });
                    return !isValid;
                case 'symbol':
                    rowKeys.forEach(function (key) {
                        var symbolizers = style.rules[key].symbolizers;
                        symbolizers.forEach(function (symbolizer) {
                            var kind = symbolizer.kind;
                            if (kind !== 'Mark' && kind !== 'Icon') {
                                isValid = false;
                            }
                        });
                    });
                    return !isValid;
                case 'color':
                    rowKeys.forEach(function (key) {
                        var symbolizers = style.rules[key].symbolizers;
                        symbolizers.forEach(function (symbolizer) {
                            var kind = symbolizer.kind;
                            if (kind === 'Icon') {
                                isValid = false;
                            }
                        });
                    });
                    return !isValid;
                default:
                    return !isValid;
            }
        };
        _this.createFooter = function () {
            var locale = _this.props.locale;
            var _a = _this.state, style = _a.style, selectedRowKeys = _a.selectedRowKeys;
            var allowRemove = selectedRowKeys.length > 0 && selectedRowKeys.length < style.rules.length;
            var allowClone = selectedRowKeys.length > 0;
            return (React.createElement(antd_1.Menu, { mode: "horizontal", onClick: _this.onTableMenuClick, selectable: false },
                React.createElement(antd_1.Menu.Item, { key: "addRule" },
                    React.createElement(antd_1.Icon, { type: "plus" }),
                    locale.addRuleBtnText),
                React.createElement(antd_1.Menu.Item, { key: "cloneRules", disabled: !allowClone },
                    React.createElement(antd_1.Icon, { type: "copy" }),
                    locale.cloneRulesBtnText),
                React.createElement(antd_1.Menu.Item, { key: "removeRule", disabled: !allowRemove },
                    React.createElement(antd_1.Icon, { type: "minus" }),
                    locale.removeRulesBtnText),
                React.createElement(antd_1.Menu.SubMenu, { title: React.createElement("span", null,
                        React.createElement(antd_1.Icon, { type: "menu-unfold" }),
                        React.createElement("span", null, locale.multiEditLabel)), disabled: selectedRowKeys.length <= 1 },
                    React.createElement(antd_1.Menu.Item, { key: "color", disabled: _this.disableMenu('color', selectedRowKeys) }, locale.colorLabel),
                    React.createElement(antd_1.Menu.Item, { key: "size", disabled: _this.disableMenu('size', selectedRowKeys) }, locale.radiusLabel),
                    React.createElement(antd_1.Menu.Item, { key: "opacity" }, locale.opacityLabel),
                    React.createElement(antd_1.Menu.Item, { key: "symbol", disabled: _this.disableMenu('symbol', selectedRowKeys) }, locale.symbolLabel))));
        };
        _this.state = {
            style: props.style || Style.defaultProps.style,
            selectedRowKeys: [],
            colorModalVisible: false,
            sizeModalVisible: false,
            opacityModalVisible: false,
            symbolModalVisible: false,
            ruleGeneratorWindowVisible: false,
            hasError: false
        };
        return _this;
    }
    Style.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var diffProps = !_isEqual(this.props, nextProps);
        var diffState = !_isEqual(this.state, nextState);
        return diffProps || diffState;
    };
    Style.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.style && !_isEqual(this.props.style, prevProps.style)) {
            this.setState({
                style: this.props.style
            });
        }
    };
    Style.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            hasError: true
        });
    };
    Style.prototype.render = function () {
        var _this = this;
        if (this.state.hasError) {
            return React.createElement("h1", null, "An error occured in the Style UI.");
        }
        var rules = [];
        var _a = this.props, compact = _a.compact, dataProjection = _a.dataProjection, filterUiProps = _a.filterUiProps, ruleNameProps = _a.ruleNameProps, ruleRendererType = _a.ruleRendererType, sldRendererProps = _a.sldRendererProps, enableClassification = _a.enableClassification, locale = _a.locale, data = _a.data, iconLibraries = _a.iconLibraries, showAmountColumn = _a.showAmountColumn, showDuplicatesColumn = _a.showDuplicatesColumn, colorRamps = _a.colorRamps, colorSpaces = _a.colorSpaces, useBrewerColorRamps = _a.useBrewerColorRamps;
        var _b = this.state, style = _b.style, selectedRowKeys = _b.selectedRowKeys, colorModalVisible = _b.colorModalVisible, sizeModalVisible = _b.sizeModalVisible, opacityModalVisible = _b.opacityModalVisible, symbolModalVisible = _b.symbolModalVisible, ruleGeneratorWindowVisible = _b.ruleGeneratorWindowVisible;
        if (style) {
            rules = style.rules;
        }
        var formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        };
        return (React.createElement("div", { className: "gs-style" },
            React.createElement("div", { className: "gs-style-name-classification-row" },
                React.createElement(antd_1.Form.Item, __assign({ label: locale.nameFieldLabel }, formItemLayout),
                    React.createElement(NameField_1.default, { value: this.state.style.name, onChange: this.onNameChange, placeholder: locale.nameFieldPlaceholder })),
                enableClassification ?
                    React.createElement(antd_1.Button, { className: "gs-style-rulegenerator", onClick: this.showRuleGeneratorWindow, disabled: !data }, locale.ruleGeneratorWindowBtnText) : null),
            (!ruleGeneratorWindowVisible) ? null :
                React.createElement(RuleGeneratorWindow_1.default, { y: 0, internalDataDef: data, onClose: this.onRuleGeneratorWindowClose, onRulesChange: this.onRulesChange, colorRamps: colorRamps, useBrewerColorRamps: useBrewerColorRamps, colorSpaces: colorSpaces }),
            compact
                ? React.createElement(RuleTable_1.default, { rules: rules, onRulesChange: this.onRulesChange, rowSelection: {
                        selectedRowKeys: selectedRowKeys,
                        onChange: this.onRulesSelectionChange
                    }, rendererType: ruleRendererType, sldRendererProps: sldRendererProps, filterUiProps: filterUiProps, data: data, footer: this.createFooter, iconLibraries: iconLibraries, showAmountColumn: showAmountColumn, showDuplicatesColumn: showDuplicatesColumn, colorRamps: colorRamps })
                : rules.map(function (rule, idx) { return React.createElement(Rule_1.default, { key: 'rule_' + idx, rule: rule, onRemove: _this.removeRule, internalDataDef: data, onRuleChange: _this.onRuleChange, dataProjection: dataProjection, filterUiProps: filterUiProps, ruleNameProps: ruleNameProps, rendererType: ruleRendererType, sldRendererProps: sldRendererProps, iconLibraries: iconLibraries, colorRamps: colorRamps }); }),
            compact ? null :
                React.createElement(antd_1.Button, { style: { 'marginBottom': '20px', 'marginTop': '20px' }, icon: "plus", size: "large", onClick: this.addRule }, locale.addRuleBtnText),
            React.createElement(BulkEditModals_1.default, { colorModalVisible: colorModalVisible, sizeModalVisible: sizeModalVisible, opacityModalVisible: opacityModalVisible, symbolModalVisible: symbolModalVisible, selectedRowKeys: selectedRowKeys, updateMultiColors: this.updateMultiColors, updateMultiSizes: this.updateMultiSizes, updateMultiOpacities: this.updateMultiOpacities, updateMultiSymbols: this.updateMultiSymbols, style: this.state.style, iconLibraries: iconLibraries, modalsClosed: function () { return _this.setState({
                    colorModalVisible: false,
                    sizeModalVisible: false,
                    opacityModalVisible: false,
                    symbolModalVisible: false
                }); } })));
    };
    Style.componentName = 'Style';
    Style.defaultProps = {
        compact: false,
        locale: en_US_1.default.GsStyle,
        style: {
            name: 'My Style',
            rules: []
        },
        enableClassification: true
    };
    return Style;
}(React.Component));
exports.Style = Style;
exports.default = LocaleWrapper_1.localize(Style, Style.componentName);
//# sourceMappingURL=Style.js.map